import { stripCursorDisplayTokens } from "./cursor-token-display";

export interface AgentPointToken {
  screen: number;
  x: number;
  y: number;
}

const POINT_RE =
  /\[\s*POINT\s*:\s*screen\s*=\s*(\d+)\s*,\s*x\s*=\s*(-?\d+)\s*,\s*y\s*=\s*(-?\d+)\s*\]/g;

export function extractPointToken(
  text: string | undefined,
): AgentPointToken | null {
  if (!text) return null;
  POINT_RE.lastIndex = 0;
  let match: RegExpExecArray | null;
  let last: AgentPointToken | null = null;
  while ((match = POINT_RE.exec(text)) !== null) {
    last = {
      screen: Number(match[1]),
      x: Number(match[2]),
      y: Number(match[3]),
    };
  }
  return last;
}

/** Display text for an optional cursor bubble field. */
export function stripPointTokens(text: string | undefined): string | undefined {
  return text === undefined ? undefined : stripCursorDisplayTokens(text);
}
